<template>
    <div class="ui-slider">
        <div v-show="isDesktop" class="ui-slider-controls">
            <button ref="$prevSlide" type="button" class="prev-slide disabled" @click="swiper.prev()">
                <svg viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.06204 0.132636L7.72635 0.505245C7.37859 3.08865 5.88816 5.24977 3.9506 5.84594L19.6001 5.84594L19.6001 7.28669L3.9506 7.28669C5.88816 7.88286 7.37859 10.044 7.72635 12.6274L6.06204 13C5.83848 9.39813 3.62768 7.5351 0.969748 7.28669L0.969748 5.84594C3.62768 5.59754 5.83848 3.7345 6.06204 0.132636Z"
                        fill="black"
                    />
                </svg>
            </button>
            <button ref="$nextSlide" type="button" class="next-slide" @click="swiper.next()">
                <svg viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M13.9375 12.8674L12.2732 12.4948C12.6209 9.91135 14.1114 7.75023 16.0489 7.15406H0.399414V5.71331H16.0489C14.1114 5.11714 12.6209 2.95602 12.2732 0.372607L13.9375 0C14.161 3.60187 16.3718 5.4649 19.0298 5.71331V7.15406C16.3718 7.40246 14.161 9.26549 13.9375 12.8674Z"
                        fill="black"
                    />
                </svg>
            </button>
        </div>

        <ClientOnly>
            <swiper-container ref="containerRef" class="swiper-container swiper-stretch">
                <slot name="sliders" />
            </swiper-container>
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
const containerRef = ref<any>(null);
const $prevSlide = ref<HTMLButtonElement | null>(null);
const $nextSlide = ref<HTMLButtonElement | null>(null);
const isDesktop = useMediaQuery('(min-width: 1181px)');

const swiper = useSwiper(containerRef, {
    loop: false,
    autoplay: {
        delay: 5000
    },
    breakpointsBase: 'window',
    breakpoints: {
        0: {
            slidesPerView: 1.35,
            slidesPerGroup: 1,
            spaceBetween: 16,
            slidesOffsetBefore: 16
        },
        768: {
            slidesPerView: 2.35,
            slidesPerGroup: 1,
            spaceBetween: 24,
            slidesOffsetBefore: 75
        },
        1440: {
            slidesPerView: 3.35,
            slidesPerGroup: 1,
            spaceBetween: 24,
            slidesOffsetBefore: 75
        },
        1665: {
            slidesPerView: 4.35,
            slidesPerGroup: 1,
            spaceBetween: 24,
            slidesOffsetBefore: 100
        }
    }
});

onMounted(() => {
    nextTick(() => {
        if (containerRef.value && $prevSlide.value && $nextSlide.value) {
            containerRef.value.addEventListener('swiperprogress', (event: Event) => {
                const progress = ((event as CustomEvent<any[]>).detail?.[0]?.progress as number | undefined) ?? 0;
                if (progress > 0) $prevSlide.value?.classList.remove('disabled');
                if (progress == 0) $prevSlide.value?.classList.add('disabled');
                if (progress < 1) $nextSlide.value?.classList.remove('disabled');
                if (progress == 1) $nextSlide.value?.classList.add('disabled');
            });
        }
    });
});
</script>
